import { Injectable } from '@angular/core';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { navCode } from '../../constants/channel.constants';
import { CardTypeModel } from '../../models/abre-cuentas.model';

import { BenefitsModel } from '../../models/agreements.model';
import { LogDeviceModel } from '../../models/log-device.model';
import { NumberPipe } from '../../pipe/number.pipe';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import { RequestService } from '../request/request-onboarding.service';
import { IProductsModel } from '../../models/products.model';
import { ProductsService } from '../products/products.service';
import { BitacoraService } from '../bitacora/bitacora.service';
import { OpEnum } from '../../enums/op.enum';
import { ParametersService } from '../parameters/parameters.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { CaptureService } from '../capture/capture.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  devicePrint = new LogDeviceModel();

  valueAmountKeys = {
    'Mastercard': 'value_master',
    'Visa': 'value_visa',
    'Visa LifeMiles': 'value_visalf',
  };

  firmlyApproved;

  private productIsReady$ = new BehaviorSubject<boolean>(false);
  quantity: string;

  constructor(
    private requestService: RequestService,
    private bioCatchService: BioCatchService,
    private abreCuentasService: AbreCuentasService,
    private numberpipe: NumberPipe,
    private navigationService: NavigationService,
    private firmlyApprovedService: FirmlyApprovedService,
    private productsService: ProductsService,
    private bitacoraService: BitacoraService,
    private parametersService: ParametersService,
    private captureService: CaptureService,
  ) {
  }

  /**
   * Validación de aceptación de términos y condiciones, registro en la bítacora
   *
   * *Terms and conditions acceptance validation*
   */
  async termsAndConditions(): Promise<any> {
    try {
      const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
      this.devicePrint.device = this.abreCuentasService.getDeviceInfo();
      if (this.devicePrint !== undefined && this.devicePrint !== null) {
        this.devicePrint.device.ip = ipBiocatch;
        this.devicePrint.terms_type = 'term_condicion_acept';
        this.devicePrint.device.event_name = 'term_condicion_acept';
        this.abreCuentasService.setdeviceInfo(this.devicePrint);
        return this.requestService.saveDataInBitacora(this.devicePrint);
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Función asíncrona para enviar la información de configuración
   *
   * *Async Function that sends config*
   *
   * @type {function}
   * @returns {Promise}
   */
  async offersConfig(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .offersConfig(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función guardar información financiera
   *
   * *Function that saves financial info*
   *
   * @param {any} body
   */
  async getCardCategoryByBrand(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .getCardCategoryByBrand(body)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de beneficios
   *
   * *Async Function that get benefits*
   *
   * @type {function}
   * @returns {Promise}
   */
  async offersGetBenefits(agreementCode: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .offersGetBenefits(agreementCode)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función asíncrona para enviar la información de beneficios
   *
   * *Async Function that get benefits*
   *
   * @type {function}
   * @returns {Promise}
   */
  async benefitsFilter(benefitsList: BenefitsModel[]): Promise<any> {
    const benefitListFiltered: string[] = [];
    const listBenefitsCombinationFlag: BenefitsModel[] = [];
    benefitsList.forEach(benefit => {
      switch (benefit.benefit_id) {
        case '638':
          if (benefit.quantity === '999') {
            benefitListFiltered.push(`Retiros ilimitados en ${benefit.type}`);
          } else if (benefit.quantity !== '0') {
            if (benefit.combination_flag) {
              listBenefitsCombinationFlag.push(benefit);
            } else {
              benefitListFiltered.push(
                `${benefit.quantity} Retiros en ${benefit.type}`,
              );
            }
          }
          break;
        case '685':
          const valor = this.numberpipe.transform(
            benefit.amount_benefit.amount
              .toString()
              .slice(
                0,
                benefit.amount_benefit.amount.toString().length -
                benefit.amount_benefit.decimals,
              ),
            'document',
            '.',
          );
          console.log('VALOR', valor);
          const agreementSelected =
            this.abreCuentasService.getAgreementSelected();
          const quantity = parseInt(benefit.quantity, 10);
          if (agreementSelected.agreement_code === '1606') {
            benefitListFiltered.push(
              'Sin cuota de manejo, mientras recibas tu nómina',
            );
          } else if (valor && quantity > 1) {
            benefitListFiltered.push(
              `Cuota de manejo $ ${valor} mensuales con exoneración de ${quantity} meses`,
            );
          } else {
            benefitListFiltered.push('Sin cuota de manejo');
          }
          break;
        default:
          break;
      }
    });
    if (listBenefitsCombinationFlag.length > 0) {
      let final_text_withdrawals = '';
      let quantity_combitation_flag = 0;
      listBenefitsCombinationFlag.forEach(benefits_combination_flag => {
        if (+benefits_combination_flag.quantity > quantity_combitation_flag) {
          quantity_combitation_flag = +benefits_combination_flag.quantity;
        }
      });
      final_text_withdrawals += `${quantity_combitation_flag} Retiros en otras redes `;
      benefitListFiltered.push(final_text_withdrawals);
    }
    benefitListFiltered.push(
      'Transferencias digitales ilimitadas desde y hacia otros bancos.',
    );
    this.abreCuentasService.setBenefitsList(benefitListFiltered);
  }

  sendCardInformation() {
    this.firmlyApproved = this.firmlyApprovedService.isFirmlyApproved();
    const { selectedProduct } =
      this.abreCuentasService.getPayDayProductSelected();
    if (Array.isArray(selectedProduct)) {
      this.cardInformationMultiproduct(selectedProduct);
      return;
    }

    const detailTC = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC);

    const resultPco = this.firmlyApproved
      ? false
      : this.abreCuentasService.getPcoModel();
    let detailTC_FirmlyApproved;
    let productFirmlyApproved;
    if (this.firmlyApproved) {
      productFirmlyApproved =
        this.firmlyApprovedService.getProduct_FirmlyApproved(
          BUSINESS_CONST.PRODUCT_CODE_TCR,
        );
      detailTC_FirmlyApproved = detailTC[0];
      console.log(
        'firmlyApproved: ',
        this.firmlyApproved,
        '\n productFirmlyApproved: ',
        productFirmlyApproved,
        'DetailTC: ',
        detailTC,
      );
    }
    const body = {
      data: {
        brand: this.firmlyApproved
          ? detailTC_FirmlyApproved.brand.replace('LifeMiles', 'LIFE MILES').toUpperCase()
          : selectedProduct
            ? selectedProduct.label
              .replace('LifeMiles', 'LIFE MILES')
              .toUpperCase()
            : '',
        campaign: this.firmlyApproved
          ? this.firmlyApprovedService.getOfferType_Channel()
          : 'Itau Extremo',
        invoice_cycle: '1',
        creditcard_amount: {
          currency: resultPco
            ? this.getCurrency(resultPco)
            : this.firmlyApproved
              ? detailTC_FirmlyApproved.limit_amount.currency
              : 0,
          amount: resultPco
            ? this.getAmount(resultPco)
            : this.firmlyApproved
              ? detailTC_FirmlyApproved.limit_amount.amount
              : 0,
          decimals: 0,
        },
        all_products: true,
        simulation_type: 'detallada',
      },
    };
    console.log('Envio a CardCategory >>> body: ', body);
    this.getCardCategoryByBrand(body).then((result: any) => {
      try {
        console.log('Obteniendo el CardTypes: ', result);
        // if (result.status === 200) {
        //   this.abreCuentasService.setCardTypeModel(result.data[0]);
        if (+result.status === 200) {
          result.body.data[0].brand = body.data.brand;
          this.abreCuentasService.setCardTypeModel(result.body.data[0]);
          if (this.abreCuentasService.getUserJemelii()) {
            this.navigationService.nextStep('203');
          } else if (!this.abreCuentasService.viewOptionMultiProduct) {
            this.navigationService.nextStep('200');
          } else {
            this.navigationService.nextStep(
              this.navigationService.nextMulti(
                this.abreCuentasService.getProductsSelects(),
              ),
            );
          }
        } else {
          if (result.status === 500) {
            throw 500;
          }
          this.abreCuentasService.caseInfoError('512');
          this.navigationService.nextStep('121');
        }
      } catch (error) {
        this.navigationService.navigateToGeneralInformation('500');
      }
    });
  }

  async cardInformationMultiproduct(selectedProduct) {
    const cardTypes = {};
    const productsMulti: any[] = [];
    console.log('cardInformationMultiproduct: ', selectedProduct);

    const resultPcoTc =
      this.firmlyApproved
        ? this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
        : this.abreCuentasService.getproductSelected().product_type ===
          BUSINESS_CONST.MULTI
          ? this.abreCuentasService
            .getPcoModel()
            .granted_product_multi.find(
              prod => prod.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC,
            )
          : this.abreCuentasService.getPcoModel().granted_product;

    if (resultPcoTc === undefined) {
      return;
    }

    const configValues = this.abreCuentasService.getConfigurationValues();
    console.log('abrecuentas Service: ', this.abreCuentasService, '\n resultPCO: ', resultPcoTc);
    for (const product of selectedProduct) {
      const brand_select = this.firmlyApprovedService.selectedBrand(product.elementId);
      const body = {
        data: {
          brand: this.firmlyApproved
            ? brand_select.replace('LifeMiles', 'LIFE MILES').toUpperCase()
            : product.label.replace('LifeMiles', 'LIFE MILES').toUpperCase(),
          campaign: this.firmlyApproved ? this.firmlyApprovedService.getOfferType_Channel() : 'Itau Extremo',
          invoice_cycle: '1',
          creditcard_amount: this.firmlyApproved
            ? resultPcoTc.find(card => card.brand === brand_select).limit_amount
            : {
              currency: resultPcoTc.limit_amount.currency,
              amount: Number(configValues[this.valueAmountKeys[product.label]]),
              decimals: 0,
            },
          all_products: true,
          simulation_type: 'detallada',
        },
      };
      console.log('body', body);

      productsMulti.push({
        brand: product.label,
        product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
        limit_amount: this.firmlyApproved
          ? resultPcoTc.find(card => card.brand === brand_select).limit_amount
          : {
            currency: resultPcoTc.limit_amount.currency,
            amount: Number(configValues[this.valueAmountKeys[product.label]]),
            decimals: 0,
          },
      });
      console.log('Envio a CardCategory >>> body: ', body);
      await this.getCardCategoryByBrand(body).then((result: any) => {
        try {
          console.log('Result 337: ', result);
          if (+result.status === 200) {
            cardTypes[product.label] = result.body.data[0];
            cardTypes[product.label].brand = product.label;
          } else {
            if (result.status === 500) {
              throw 500;
            }
            this.abreCuentasService.caseInfoError('512');
            this.navigationService.nextStep('121');
          }
        } catch (error) {
          this.navigationService.navigateToGeneralInformation('500');
        }
      });
    }
    console.log('CardTypes: ', cardTypes);
    if (this.firmlyApproved) {
      this.abreCuentasService.getPcoModel().granted_product_multi = this.firmlyApprovedService.getDetailProductsMulti();
    }
    console.log('AbreCuentasService: ', this.abreCuentasService);
    console.log('GrantedProductMulti: ', this.abreCuentasService.getPcoModel().granted_product_multi);
    this.abreCuentasService.getPcoModel().granted_product_multi =
      this.abreCuentasService
        .getPcoModel()
        .granted_product_multi.filter(
          prod =>
            prod.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC &&
            (prod.brand === undefined || prod.brand === ''),
        );

    this.abreCuentasService.getPcoModel().granted_product_multi =
      this.abreCuentasService
        .getPcoModel()
        .granted_product_multi.concat(productsMulti);
    this.abreCuentasService.setCardTypesModel(cardTypes);
    console.log('cardTypes: ', this.abreCuentasService.getCardTypesModel());
    if (!this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep('200');
    } else {
      this.navigationService.nextStep(
        this.navigationService.nextMulti(
          this.abreCuentasService.getProductsSelects(),
        ),
      );
    }
  }

  getCurrency(resultPco: any) {
    if (resultPco.granted_product_multi.length > 0) {
      return resultPco.granted_product_multi.filter(
        fil => fil.product_type === 'creditCard',
      )[0].limit_amount.currency;
    } else {
      return resultPco.granted_product.limit_amount.currency;
    }
  }

  getAmount(resultPco: any) {
    console.log('resultPco_', resultPco);
    if (resultPco.granted_product_multi.length > 0) {
      let amount = resultPco.granted_product_multi.filter(
        fil => fil.product_type === 'creditCard',
      )[0].limit_amount.amount;
      return amount.toString().replace('$ ', '').split(/\./).join('');
    } else {
      let amount = resultPco.granted_product.limit_amount.amount;
      return amount.toString().replace('$ ', '').split(/\./).join('');
    }
  }

  /**
   * Función guardar información de financiera
   *
   * *Function that saves financial info*
   *
   */
  async getRatesByAllies(codeallies: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService
        .validateInfo(codeallies)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  /**
   * Función encargada de leer el producto que el usuario
   * seleccionó en la opción de Productos, dejando de
   * esta forma de una vez el producto seleccionado en Onboarding
   * para iniciar el respectivo Flujo.
   * @param {string} productPreSelected - Producto seleccionado
   */
  selectProduct(productPreSelected: string) {
    console.warn('Producto preseleccionado: ', productPreSelected);
    const product = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE);
    console.log('Productos pre cargados: ', product);
    let productSelected = product.find((prod: IProductsModel) => prod.product_code === productPreSelected);
    console.warn('PRODUCTO SELECCIONADO: ', productSelected);
    if (productSelected) {
      this.validateBiocatch(productSelected);
    } else {
      this.setProductIsReady(true);
    }
  }

  validateBiocatch(product: IProductsModel) {
    this.abreCuentasService.setproductSelected(product);
    this.bioCatchService
      .checkCountry(false)
      .then(response => {
        if (response.data.response || !this.bioCatchService.getGeoServiceComplete()) {
          this.selectProductType(product);
        } else {
          this.navigationService.navigateToGeneralInformation('dsbException');
        }
      }, error => {
        console.error('BiocatchError..');
        console.error(error);
        this.navigationService.navigateToGeneralInformation('500');
        if (!this.abreCuentasService.getPostlogin()) {
          this.navigationService.pageLoadTag(false, ['pv415', '', '', '']);
        }
      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  /**
   * Función que permite identificar el tipo del producto seleccionado por el usuario,
   * permite identificar los activos de los pasivos.
   * @param {IProductsModel} product - Producto seleccionado
   */
  async selectProductType(product: IProductsModel) {
    this.productsService.assignProductType(product).then(async () => {
      console.log('Producto seleccionado: ', product);
      if (product.name === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT && this.abreCuentasService.getPostlogin()) {
        await this.validateDataConsultationRquest();
      } else if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
        this.productsService.getAgreementsOffers()
          .then(() => {
            console.log('Cargue exitoso de convenios.');
            this.setProductIsReady(true);
          })
          .catch(() => this.navigationService.navigateToGeneralInformation('500'));
      } else {
        this.setProductIsReady(true);
      }
      this.saveDataInBitacora(product);
    }).catch(error => {
      console.error(error);
      this.setProductIsReady(false);
      this.navigationService.navigateToGeneralInformation('500');
    });
  }

  private async validateDataConsultationRquest() {
    const requestData = await this.captureService.getRequestsByClient(
      `${this.abreCuentasService.getDocumentInfo().document_number}_${this.abreCuentasService
        .getDocumentInfo().document_type.replace('0', '')}`);
    console.log('getRequestsByClient: ', requestData);

    if (requestData.code !== '200') {
      this.navigationService.setCodeError('131');
      // this.navigationService.navigateToGeneralInformation('131');
    } else if (requestData.code === '200' && requestData.data.length === 0) {
      this.navigationService.setCodeError('141');
      // this.navigationService.navigateToGeneralInformation('141');
    }
    this.abreCuentasService.setCustomerRequests(requestData.data);
    this.setProductIsReady(true);
  }

  private saveDataInBitacora(product: IProductsModel) {
    const biocatchInfo: any = this.bioCatchService.getBiocatchInfo();
    if (this.abreCuentasService.getIsPortal()) {
      this.bitacoraService.saveDataInBitacora('Chanel_131_Portal');
    }
    this.bitacoraService.saveDataInBitacora(product.product_type);
    if (!!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
      const bitacoraEvent = `geo_biocatch_${biocatchInfo.ipGeoCity}_${biocatchInfo.ipGeoCountry}`;
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
  }

  setProductIsReady(isReady: boolean): void {
    this.productIsReady$.next(isReady);
  }
  getProductIsReady(): Observable<boolean> {
    return this.productIsReady$.asObservable();
  }

}
